//libs
import React, { memo, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

// global components
import { SHEET_TRANSITION, OverlaySheetContext } from 'shared/components/OverlaySheet';

// components
import Header from './components/Header/Header';
import ProductRenderer from './components/ProductsRenderer/ProductsRenderer';
import SomethingWentWrong from 'shared/components/SomethingWentWrongV2';
import IOElement from 'shared/components/IOElement';

//styles
import { OverlaySheet, ErrorState } from './styles';

//store
import { getSimilarData, widgetError } from 'store/widgets/selectors';
import PlaceHolder from './components/PlaceHolder';

interface Props {
  closeSheet: VoidFunction;
  productId?: string;
  selectedProduct: Listing.IProduct;
  isFetching: boolean;
}

const ViewSimilarOverlay = ({ closeSheet, selectedProduct, isFetching }: Props) => {
  const widgetData = useSelector(getSimilarData);
  const hasError = useSelector(widgetError);
  const [isScroll, setIsScroll] = useState(false);

  const renderProducts = useMemo(() => {
    if (isFetching) return <PlaceHolder />;
    if (hasError || isEmpty(widgetData)) {
      return (
        <OverlaySheetContext.Consumer>
          {({ doHide }) => (
            <ErrorState>
              <SomethingWentWrong onBack={doHide} />
            </ErrorState>
          )}
        </OverlaySheetContext.Consumer>
      );
    }
    return <ProductRenderer products={widgetData.products} />;
  }, [hasError, isFetching, widgetData]);

  return (
    <OverlaySheet
      navKey="dweb-view-similar"
      disableNav
      transitionFrom={SHEET_TRANSITION.RIGHT}
      onHide={closeSheet}
      hasError={hasError || isEmpty(widgetData)}
    >
      <IOElement
        onHidden={() => setIsScroll(true)}
        onVisible={() => setIsScroll(false)}
        options={{ rootMargin: '80% 0px 0px 0px' }}
      />
      <Header selectedProduct={selectedProduct} isScroll={isScroll} />
      {renderProducts}
    </OverlaySheet>
  );
};

export default memo(ViewSimilarOverlay);
